/**
* index.jsx
*
* This is the entry file for the application, only setup and boilerplate
* code.
*/

import 'core-js/stable'
import 'regenerator-runtime/runtime'

// ionic-import
import '@ionic/react/css/core.css'
import { setupIonicReact } from '@ionic/react'

import React from 'react'
import { createRoot } from 'react-dom/client'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/locale-data/en'
import '@formatjs/intl-pluralrules/locale-data/it'
import MainContainer from 'Containers/MainContainer'
import store, { createReduxHistory } from 'Store/createStore'
import { initLogger } from 'Utility/logger'
import { Capacitor } from '@capacitor/core'
import { getCookieSync, expireCookieSync } from 'Utility/globalMethods'

const history = createReduxHistory(store)

setupIonicReact()

// if (process.env.NODE_ENV === 'development') {
//   import('sa11y/dist/js/lang/en')
//     .then((sa11yLang) => {
//       import('sa11y/dist/js/sa11y.esm')
//         .then((sa11yModule) => {
//           sa11yModule.Lang.addI18n(sa11yLang.default.strings)
//           // eslint-disable-next-line no-unused-vars
//           const sa11y = new sa11yModule.Sa11y({
//             checkRoot: 'body'
//           })
//         })
//     })
// }

// ========================================================
// Render Setup
// ========================================================
const routes = Object.fromEntries(Object.entries(process.env).filter(([key]) => key.includes('ROUTE')))
const filter = Object.keys(routes).filter(a => routes[a] === 'true')

const MOUNT_NODE = document.getElementById('root')
const authRoutes = require('Route/routes').default(store)
const unauthRoutes = require('Route/routes').createUnauthRoutes(store)
const root = createRoot(MOUNT_NODE)
const regex = new RegExp(`^(${filter.join('|').replace(/route_/ig, '')})$`, 'i')

const queryParams = new URLSearchParams(location.search)
const jweFromQuery = queryParams.get('context')
const jweFromCookie = getCookieSync('context')

authRoutes.routes = authRoutes.routes.filter(a => regex.test(a.key))
unauthRoutes.routes = unauthRoutes.routes.filter(a => regex.test(a.key))

let logged = false
if (jweFromQuery) {
  window.sessionStorage.setItem('jwe', jweFromQuery)
  const url = new URL(window.location.href)
  url.searchParams.delete('context')
  window.history.replaceState({}, document.title, url.pathname + url.search)
  logged = true
} else if (jweFromCookie) {
  window.sessionStorage.setItem('jwe', jweFromCookie)
  expireCookieSync('context')
  logged = true
}

if (getCookieSync('context')) {
  window.sessionStorage.setItem('jwe', getCookieSync('context'))
  expireCookieSync('context')
  logged = true
}
if (window.sessionStorage.getItem('jwe')) {
  logged = true
}

if (process.env.DEBUG_MODE === 'true') {
  initLogger()
}

if (process.env.ISMOCK === 'true') {
  window.sessionStorage.setItem('jwe', 'asc7gdsv0b8s7vg8iubcpugdcs7o8gcioV8SACC.KDSF9SPVASDdsf8sad90fF')
  logged = true
}

root.render(<MainContainer store={store} authRoutes={authRoutes} unauthRoutes={unauthRoutes} logged={logged} history={history} />)

if (module.hot) {
  module.hot.accept('Route/routes', () =>
    setImmediate(() => {
      root.render(<MainContainer store={store} authRoutes={authRoutes} unauthRoutes={unauthRoutes} logged={logged} history={history} />)
    })
  )
}

if (process.env.NODE_ENV === 'production') {
  if (!window.console) window.console = {}
  const methods = ['log', 'debug', 'warn', 'info', 'error']
  for (let i = 0; i < methods.length; i += 1) {
    console[methods[i]] = () => { }
  }
  require('@lcdp/offline-plugin/runtime').install()
}

if (process.env.DIDOMI_ID && !Capacitor.isNativePlatform()) {
  const { setDidomi } = require('Utility/didomi')
  setDidomi(process.env.DIDOMI_KEY, process.env.DIDOMI_ID)
}

if (process.env.GTM_ID) {
  const { setGtm } = require('Utility/gtm')
  setGtm(window, document, 'script', 'dataLayer', process.env.GTM_ID)

  if (Capacitor.isNativePlatform()) {
    const { FirebaseAnalytics } = require('@capacitor-firebase/analytics')

    window.FirebasePlugin = {
      logEvent: async (eventName, params = {}, success, error) => {
        try {
          await FirebaseAnalytics.logEvent({ name: eventName, params })
          if (success) success()
        } catch (err) {
          if (error) error(err)
        }
      },
      setUserId: async (userId, success, error) => {
        try {
          await FirebaseAnalytics.setUserId({ userId })
          if (success) success()
        } catch (err) {
          if (error) error(err)
        }
      },
      setUserProperty: async (name, value, success, error) => {
        try {
          await FirebaseAnalytics.setUserProperty({ key: name, value })
          if (success) success()
        } catch (err) {
          if (error) error(err)
        }
      }
    }
  } else if (!window.firebase) {
    window.firebase = {
      analytics: () => ({
        logEvent: () => { }
      })
    }
  }
}
